module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/desenrola1x-523cb09b147bdb01207cbcc18245d40d.png";